// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth, GoogleAuthProvider} from "firebase/auth";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDxLIA0DmvYCBcrMJpLFFIBFRvc_uN2Zwg",
  authDomain: "nova-type.firebaseapp.com",
  projectId: "nova-type",
  storageBucket: "nova-type.appspot.com",
  messagingSenderId: "393406962403",
  appId: "1:393406962403:web:7e65b59332c690105383d6",
  measurementId: "G-TJ0MCJPEDZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' }); // This forces the user to pick an account when they press the log in button I beleive (From the google popup, they may have multiple accounts)
export const auth = getAuth(app);
const analytics = getAnalytics(app);
firebase.initializeApp(firebaseConfig);
export const dataBase = firebase.firestore();